/**
 * Bootstrap helper used by useBootstrapStore.
 *
 * Dedicated admin bootstrap: seeds the graph store from the master-token admin
 * data endpoint (routes/admin.js adminGraphData) instead of the URL-driven
 * path. Entered only when the server set window.__ADMIN_VIEW__ (never a
 * client-supplied param) — see routes/admin.js adminGraphPage.
 */
import { useGraphStore } from '../useGraphStore'
import { useContextsStore } from '../useContextsStore'
import { ACCESS_MODES } from '../contextAccess'
import { processStatements, initTopicsFromGraph } from './processStatements'

export const bootstrapAdminView = async ({
    userId,
    contextName,
    graphOwner,
    addContexts = [],
}) => {
    // Merged (union) view members ride along as repeatable addcontext params
    // — the data endpoint unions their statements into one graph.
    const params = new URLSearchParams({ owner: graphOwner.username })
    addContexts.forEach(name => params.append('addcontext', name))
    const response = await fetch(
        `/admin/graph/${userId}/${encodeURIComponent(
            contextName
        )}/data?${params.toString()}`
    )
    if (!response.ok) throw new Error(`admin graph load failed: ${response.status}`)
    const graphData = await response.json()

    useContextsStore.getState().setCurrentGraphOwner({
        username: graphOwner.username,
        id: graphOwner.id,
        accessMode: ACCESS_MODES.PUBLIC_OF_OTHER, // read-only presentation
    })
    useGraphStore.getState().setGraphData(graphData)

    // Mirror bootstrapContextView Step 5: seeding the graph store alone renders
    // the graph but leaves the statement panel empty — processStatements is what
    // flips `loadedStatements` and populates it (it reads statements from the
    // store via getStatements and sets currentContext itself). initTopicsFromGraph
    // derives the topics layer from the already-loaded graph clusters (no fetch).
    const statements = useGraphStore.getState().getStatements()
    await processStatements({
        statements: statements && statements.length > 0 ? statements : [],
        contextName,
        addContexts: [],
    })
    initTopicsFromGraph()
}
